import { useContext } from "react";
import { AuthContext } from "../context/auth";


export function useAuth() {
  const { user, updateUser, logoutUser } = useContext(AuthContext);

  const isM3tasUser = () => user.data.login == "m3tas";
  const isAdminUser = () => user.data.roles[0].id === 1 || isM3tasUser();
  const isGlobalUser = () => user.data.globalUser == 1;
  
  return { user, updateUser, logoutUser, isAdminUser, isM3tasUser, isGlobalUser };
}
